angular.module('unica_location.location_controllers')

.controller('LocationListController', function(
	$rootScope, $scope, $state,
	$confirm,
	LocationListService, LocationDeleteService
) {
	$scope.locationList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.loadLocations = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		LocationListService
			.list($scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.locationList = $scope.locationList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadLocations();


	$scope.asyncSelected = undefined;
	$scope.ibNoResults = false;
	$scope.loadingLocations = false;
	$scope.searchLocation = function(search) {
		$scope.loadingLocations = true;
		LocationListService
			.searchNameOrAddress(search)
			.then(function(data) {
				$scope.loadingLocations = false;
				$scope.canLoad = false;
				if ( data.length > 0 ) {
					$scope.ibNoResults = false;
					$scope.locationList = data;
					return data;
				} else {
					$scope.locationList = [];
					$scope.ibNoResults = true;
					return null;
				}
			});
	};


	$scope.$watch('asyncSelected', function() {
		if ( $scope.asyncSelected !== undefined && $scope.asyncSelected.length == 0 ) {
			$scope.canLoad = true;
			$scope.offset = 0;
			$scope.locationList = [];
			$scope.loadLocations();
		}
	});

	$scope.deleteLocation = function(locationId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare la location?',
			text: 'Confermi la cancellazione della location?'
		}).then(function() {

			$scope.showLoader();
			LocationDeleteService
				.delete( locationId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.locationList, function(location, key) {
							if ( location.id == locationId ) {
								$scope.locationList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Location eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

})

;